import EmbedModeContext, { withEmbedMode } from './EmbedModeContext';
export default EmbedModeContext;

export { withEmbedMode };